import AddTablePreSedationEN from "./AddTablePreSedationEN";

export default function toPDFMakeData(props: any) {
  return {
    pageSize: `A4`,
    pageOrientation: `portrait`,
    defaultStyle: {
      font: `THSarabunNew`,
    },
    content: [
      {
        pageBreak: ``,
        alignment: `center`,
        text: `Pre Procedural Sedation and Pre Anesthesia Informed Consent`,
        color: ``,
        decorationStyle: ``,
        decorationColor: ``,
        preserveLeadingSpaces: true,
        bold: `true`,
        width: `auto`,
        decoration: ``,
        fontSize: `18`,
      },
      {
        bold: false,
        color: ``,
        decorationStyle: ``,
        decorationColor: ``,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        decoration: ``,
        fontSize: 15,
        text: ` `,
        alignment: `left`,
        width: `auto`,
      },
      {
        columns: [
          {
            alignment: `left`,
            decoration: ``,
            decorationStyle: ``,
            color: ``,
            pageBreak: ``,
            width: 30,
            text: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            bold: false,
            decorationColor: ``,
          },
          {
            text: `I authorize the monitoring of vital bodily functions and the administration of sedatives and anesthetics`,
            decorationColor: ``,
            bold: false,
            fontSize: 15,
            alignment: `left`,
            color: ``,
            pageBreak: ``,
            decorationStyle: ``,
            width: `auto`,
            preserveLeadingSpaces: true,
            decoration: ``,
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            text: `under the direction of physician`,
            decorationStyle: ``,
            color: ``,
            fontSize: 15,
            decoration: ``,
            decorationColor: ``,
            width: `auto`,
          },
          {
            text: ` `,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: 5,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                text: props.items?.formatDoctor,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `center`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `........................................................................`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
          {
            decoration: ``,
            text: `or assigned another physician`,
            pageBreak: ``,
            alignment: `left`,
            color: ``,
            decorationStyle: ``,
            bold: false,
            decorationColor: ``,
            fontSize: 15,
            width: `auto`,
            preserveLeadingSpaces: true,
          },
          {
            text: ``,
            margin: [0, 0, 0, 0],
            width: 3,
            bold: false,
            decoration: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            color: ``,
          },
          {
            pageBreak: ``,
            decorationStyle: ``,
            alignment: `left`,
            decoration: ``,
            color: ``,
            text: `member of`,
            bold: false,
            width: `auto`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
          },
        ],
      },
      {
        decoration: ``,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        alignment: `left`,
        bold: false,
        color: ``,
        fontSize: 15,
        decorationColor: ``,
        text: `Sapiens Hospital.`,
        decorationStyle: ``,
        width: `auto`,
      },
      {
        columns: [
          {
            color: ``,
            bold: false,
            decorationStyle: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            width: 30,
            decoration: ``,
            fontSize: 15,
            text: ``,
            alignment: `left`,
            decorationColor: ``,
          },
          {
            color: ``,
            decorationColor: ``,
            width: `auto`,
            bold: false,
            alignment: `left`,
            decorationStyle: ``,
            fontSize: 15,
            decoration: ``,
            pageBreak: ``,
            text: `I, `,
            preserveLeadingSpaces: true,
          },
          {
            text: ` `,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: 5,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                text: props.items?.formatPatient,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `..................................................................................................................................................................................................,`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            text: `have been scheduled for`,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: `auto`,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
          },
          {
            text: ` `,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: 5,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                text: props.items?.formatOperation,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `..............................................................................................................................`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
          {
            text: `Procedure/ surgery.`,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: `auto`,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
          },
        ],
      },
      {
        width: `auto`,
        decorationColor: ``,
        preserveLeadingSpaces: true,
        color: ``,
        decoration: ``,
        pageBreak: ``,
        bold: false,
        decorationStyle: ``,
        alignment: `left`,
        fontSize: 15,
        text: `It has been explained to me that all forms of anesthesia involve some risks of complications. Although rare, severe unexpected complications can occur with each type of anesthesia including infection, bleeding, cognitive dysfunction, tooth injury, drug reaction, blood clots, loss of sensation, loss of vision, loss of limb function, paralysis, awareness, stroke, brain damage, heart attack or death. I understand that these risks apply to ALL forms of anesthesia and that additional or specific risks of identified below will apply to me. I understand the consequences including the risks and benefits of alternatives of procedural sedation and postprocedure analgesia. It has been explained to me that sometime an anesthetic technique that involves the use of local anesthetic, may not succeed completely and therefore another technique may have to be used including general anesthesia.`,
      },
      {
        columns: [
          {
            text: ``,
            width: 30,
            alignment: `left`,
            preserveLeadingSpaces: true,
            bold: false,
            decorationStyle: ``,
            fontSize: 15,
            pageBreak: ``,
            color: ``,
            decorationColor: ``,
            decoration: ``,
          },
          {
            width: `auto`,
            bold: false,
            alignment: `left`,
            decoration: ``,
            color: ``,
            text: `I consent to the anesthetic techniques checked below and also consent to an alternative type of `,
            decorationStyle: ``,
            decorationColor: ``,
            fontSize: 15,
            pageBreak: ``,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        alignment: `left`,
        fontSize: 15,
        text: `anesthesia, if necessary.`,
        width: `auto`,
        bold: false,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        decoration: ``,
        decorationColor: ``,
        color: ``,
      },
      {
        pageBreak: ``,
        text: ` `,
        width: `auto`,
        decorationStyle: ``,
        alignment: `left`,
        fontSize: 15,
        decoration: ``,
        color: ``,
        decorationColor: ``,
        bold: false,
        preserveLeadingSpaces: true,
      },
      {
        decorationStyle: ``,
        decorationColor: ``,
        fontSize: 15,
        decoration: ``,
        text: `Anesthetic Technique`,
        preserveLeadingSpaces: true,
        color: ``,
        width: `auto`,
        alignment: `left`,
        bold: `true`,
        pageBreak: ``,
      },
      {
        columns: [
          {
            decorationStyle: ``,
            bold: false,
            preserveLeadingSpaces: true,
            alignment: `center`,
            pageBreak: ``,
            width: `auto`,
            fontSize: 15,
            color: ``,
            decoration: ``,
            decorationColor: ``,
            text: `[  ]`,
          },
          {
            preserveLeadingSpaces: true,
            color: ``,
            alignment: `left`,
            text: ``,
            decorationColor: ``,
            bold: false,
            fontSize: 15,
            decorationStyle: ``,
            width: 5,
            pageBreak: ``,
            decoration: ``,
          },
          {
            fontSize: 15,
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
            alignment: `left`,
            bold: false,
            width: `auto`,
            text: `General anesthesia  	`,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
          },
          {
            color: ``,
            width: 75,
            bold: false,
            alignment: `left`,
            decorationColor: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            text: ``,
            pageBreak: ``,
            decoration: ``,
            decorationStyle: ``,
          },
          {
            fontSize: 15,
            width: `auto`,
            bold: false,
            pageBreak: ``,
            decoration: ``,
            text: `[  ]`,
            alignment: `center`,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            color: ``,
            decorationColor: ``,
          },
          {
            bold: false,
            alignment: `left`,
            width: 5,
            decorationColor: ``,
            text: ``,
            decoration: ``,
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            color: ``,
          },
          {
            alignment: `left`,
            decorationStyle: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            width: `auto`,
            pageBreak: ``,
            text: `Spinal and/or Epidural anesthesia `,
            decorationColor: ``,
            color: ``,
            fontSize: 15,
            bold: false,
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            pageBreak: ``,
            text: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            fontSize: 15,
            decorationColor: ``,
            decoration: ``,
            alignment: `left`,
            width: 198,
            color: ``,
          },
          {
            pageBreak: ``,
            decorationColor: ``,
            fontSize: 15,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            width: `auto`,
            alignment: `left`,
            color: ``,
            text: `(With or without sedation)`,
            decoration: ``,
            bold: false,
          },
        ],
      },
      {
        columns: [
          {
            decoration: ``,
            alignment: `left`,
            decorationColor: ``,
            bold: false,
            fontSize: 15,
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
            width: `auto`,
            text: `[  ]`,
            preserveLeadingSpaces: true,
          },
          {
            pageBreak: ``,
            fontSize: 15,
            alignment: `left`,
            bold: false,
            preserveLeadingSpaces: true,
            color: ``,
            width: 5,
            decorationStyle: ``,
            decoration: ``,
            text: ``,
            decorationColor: ``,
          },
          {
            width: `auto`,
            text: `Major/Minor nerve block`,
            pageBreak: ``,
            color: ``,
            decorationColor: ``,
            alignment: `left`,
            fontSize: 15,
            decorationStyle: ``,
            decoration: ``,
            bold: false,
            preserveLeadingSpaces: true,
          },
          {
            text: ``,
            decorationStyle: ``,
            alignment: `left`,
            decorationColor: ``,
            fontSize: 15,
            color: ``,
            pageBreak: ``,
            width: 49,
            bold: false,
            decoration: ``,
            preserveLeadingSpaces: true,
          },
          {
            decorationStyle: ``,
            fontSize: 15,
            bold: false,
            decorationColor: ``,
            width: `auto`,
            text: `[  ]`,
            color: ``,
            pageBreak: ``,
            alignment: `left`,
            decoration: ``,
            preserveLeadingSpaces: true,
          },
          {
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            bold: false,
            text: ``,
            color: ``,
            decorationStyle: ``,
            alignment: `left`,
            width: 5,
            decoration: ``,
            fontSize: 15,
          },
          {
            text: `Monitored anesthesia care`,
            decoration: ``,
            color: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decorationColor: ``,
            alignment: `left`,
            width: `auto`,
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
          },
        ],
      },
      {
        columns: [
          {
            decorationColor: ``,
            color: ``,
            text: ``,
            fontSize: 15,
            bold: false,
            pageBreak: ``,
            decorationStyle: ``,
            width: 18,
            preserveLeadingSpaces: true,
            alignment: `left`,
            decoration: ``,
          },
          {
            alignment: `left`,
            text: `(With or without sedation)`,
            decorationStyle: ``,
            bold: false,
            fontSize: 15,
            decoration: ``,
            color: ``,
            width: `auto`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
          },
          {
            decorationStyle: ``,
            fontSize: 15,
            decoration: ``,
            decorationColor: ``,
            bold: false,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            alignment: `left`,
            width: 60,
            text: ``,
            color: ``,
          },
          {
            pageBreak: ``,
            alignment: `left`,
            decorationStyle: ``,
            text: `(With or without sedation)`,
            bold: false,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            fontSize: 15,
            width: `auto`,
            color: ``,
          },
        ],
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            fontSize: 15,
            decorationStyle: ``,
            width: `auto`,
            color: ``,
            bold: false,
            text: `[  ]`,
            decorationColor: ``,
            alignment: `center`,
            decoration: ``,
            pageBreak: ``,
          },
          {
            decorationStyle: ``,
            fontSize: 15,
            alignment: `left`,
            pageBreak: ``,
            bold: false,
            preserveLeadingSpaces: true,
            decoration: ``,
            width: 5,
            text: ``,
            color: ``,
            decorationColor: ``,
          },
          {
            alignment: `left`,
            bold: false,
            decoration: ``,
            decorationStyle: ``,
            fontSize: 15,
            width: `auto`,
            text: `Sedation`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            color: ``,
            pageBreak: ``,
          },
        ],
      },
      {
        columns: [
          {
            text: ``,
            pageBreak: ``,
            decorationColor: ``,
            alignment: `left`,
            bold: false,
            width: 30,
            decorationStyle: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            color: ``,
            decoration: ``,
          },
          {
            fontSize: 15,
            decoration: ``,
            width: `auto`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
            alignment: `left`,
            text: `I understand that may use of any type of illegal drug may give rise to serious complications and must be`,
            bold: false,
          },
        ],
      },
      {
        pageBreak: ``,
        text: `disclosed to my health care providers include my anesthesiologist. In the event that I am released to go home 24 hours of surgery. I will not drive myself home or use a public conveyance. A responsible adult will take me.`,
        alignment: `left`,
        decorationColor: ``,
        bold: false,
        color: ``,
        decorationStyle: ``,
        preserveLeadingSpaces: true,
        decoration: ``,
        width: `auto`,
        fontSize: 15,
      },
      {
        columns: [
          {
            decoration: ``,
            width: 30,
            bold: false,
            text: ``,
            fontSize: 15,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            color: ``,
            pageBreak: ``,
            alignment: `left`,
          },
          {
            text: `I acknowledge that I have read this form or had it read to me, that I understand the risks, alternative and`,
            pageBreak: ``,
            alignment: `left`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decorationStyle: ``,
            width: `auto`,
            fontSize: 15,
            color: ``,
            decoration: ``,
          },
        ],
      },
      {
        text: `expected results of the anesthesia service, that I had ample time to ask questions and the answers and`,
        color: ``,
        bold: false,
        decorationColor: ``,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        width: `auto`,
        fontSize: 15,
        alignment: `left`,
        pageBreak: ``,
        decoration: ``,
      },
      {
        bold: false,
        width: `auto`,
        color: ``,
        text: `additional information provided have met with my satisfaction and that I had ample time to consider my decisions.`,
        decorationColor: ``,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        pageBreak: ``,
        alignment: `left`,
        fontSize: 15,
        decoration: ``,
      },
      {
        text: ``,
        decoration: ``,
        decorationStyle: ``,
        decorationColor: ``,
        width: `auto`,
        color: ``,
        bold: false,
        fontSize: 15,
        pageBreak: `after`,
        alignment: `left`,
        preserveLeadingSpaces: true,
        margin: [0, 0, 0, 0],
      },
      {
        columns: [
          {
            width: 30,
            decorationStyle: ``,
            fontSize: 15,
            alignment: `left`,
            text: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            pageBreak: ``,
            bold: false,
            color: ``,
            decoration: ``,
          },
          {
            pageBreak: ``,
            color: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            bold: `true`,
            decorationColor: ``,
            width: `auto`,
            alignment: `left`,
            decoration: ``,
            fontSize: 15,
            text: `For women only:`,
          },
          {
            preserveLeadingSpaces: true,
            width: 5,
            fontSize: 15,
            pageBreak: ``,
            color: ``,
            decorationStyle: ``,
            decoration: ``,
            alignment: `left`,
            bold: false,
            text: ``,
            decorationColor: ``,
          },
          {
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            decorationStyle: ``,
            text: ` If I am pregnant, I understand that elective surgery should be postponed until after`,
            decorationColor: ``,
            bold: false,
            color: ``,
            decoration: ``,
            width: `auto`,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        decoration: ``,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        fontSize: 15,
        width: `auto`,
        decorationColor: ``,
        bold: false,
        text: `the baby is born. Anesthetics penetrate the placenta and may temporarily anesthetize my baby. Although fetal complications of anesthesia during pregnancy are very rare, the risks to my baby include, but are not limited to birth defects, premature labor, permanent brain damage and death. If there is a possibility of me being pregnant, I have so informed the anesthesiologist.`,
        color: ``,
        alignment: `left`,
        decorationStyle: ``,
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            text: ``,
            width: 30,
            pageBreak: ``,
            fontSize: 15,
            decoration: ``,
            bold: false,
            decorationStyle: ``,
            color: ``,
            alignment: `left`,
            decorationColor: ``,
          },
          {
            decorationStyle: ``,
            color: ``,
            pageBreak: ``,
            decoration: ``,
            fontSize: 15,
            alignment: `left`,
            bold: false,
            decorationColor: ``,
            text: `Additional or specific risks apply to my condition and my anesthesia service: ……..................……...……………...…`,
            width: `auto`,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        bold: false,
        width: `auto`,
        preserveLeadingSpaces: true,
        alignment: `left`,
        pageBreak: ``,
        text: `..................................................................................................................................................................................................................`,
        decoration: ``,
        color: ``,
        decorationStyle: ``,
        fontSize: 15,
        decorationColor: ``,
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            decoration: ``,
            fontSize: 15,
            text: ``,
            width: 30,
            color: ``,
            alignment: `left`,
            decorationStyle: ``,
            decorationColor: ``,
            pageBreak: ``,
            bold: false,
          },
          {
            bold: false,
            decorationColor: ``,
            pageBreak: ``,
            width: `auto`,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            text: `The above information was given to me by `,
            alignment: `left`,
            color: ``,
            fontSize: 15,
          },
          {
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
            decorationStyle: ``,
            width: 5,
            preserveLeadingSpaces: true,
            bold: false,
            alignment: `left`,
            fontSize: 15,
            decoration: ``,
            text: ``,
          },
          {
            stack: [
              {
                text: props.items?.operatingData?.anes_name,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `...................................................................................................................`,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                width: `auto`,
                color: ``,
                bold: false,
                fontSize: 15,
                pageBreak: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
        ],
      },
      {
        text: ` `,
        decoration: ``,
        decorationStyle: ``,
        decorationColor: ``,
        width: `auto`,
        color: ``,
        bold: false,
        fontSize: 15,
        pageBreak: ``,
        alignment: `left`,
        preserveLeadingSpaces: true,
        margin: [0, 0, 0, 0],
      },
      {
        width: `auto`,
        decoration: ``,
        decorationStyle: ``,
        text: `I hereby AGREE to receive the treatment mentioned above.`,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        fontSize: 15,
        alignment: `left`,
        decorationColor: ``,
        bold: false,
        color: ``,
      },
      {
        bold: false,
        width: `auto`,
        text: ` `,
        decorationColor: ``,
        alignment: `left`,
        color: ``,
        decorationStyle: ``,
        fontSize: 15,
        pageBreak: ``,
        decoration: ``,
        preserveLeadingSpaces: true,
      },
      {
        columns: [
          {
            decorationColor: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            bold: false,
            alignment: `center`,
            fontSize: 15,
            decoration: ``,
            text: `Signature.................................................................`,
            color: ``,
            width: 200,
          },
          {
            preserveLeadingSpaces: true,
            decoration: ``,
            alignment: `left`,
            fontSize: 15,
            pageBreak: ``,
            decorationStyle: ``,
            width: 80,
            bold: false,
            text: `  `,
            decorationColor: ``,
            color: ``,
          },
          {
            pageBreak: ``,
            decorationColor: ``,
            decorationStyle: ``,
            fontSize: 15,
            alignment: `center`,
            bold: false,
            text: `Witness 1........................................................`,
            color: ``,
            width: 200,
            preserveLeadingSpaces: true,
            decoration: ``,
          },
        ],
      },
      {
        columns: [
          {
            text: ` `,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            width: 24,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
          },
          {
            pageBreak: ``,
            decorationColor: ``,
            decoration: ``,
            decorationStyle: ``,
            width: 200,
            fontSize: 15,
            color: ``,
            preserveLeadingSpaces: true,
            alignment: `center`,
            text: `(.............................................................)`,
            bold: false,
          },
          {
            alignment: `left`,
            fontSize: 15,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            pageBreak: ``,
            text: ``,
            width: 54,
            bold: false,
            color: ``,
            decorationColor: ``,
          },
          {
            width: 200,
            text: `(.............................................................)`,
            decorationColor: ``,
            pageBreak: ``,
            decorationStyle: ``,
            bold: false,
            color: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            decoration: ``,
            alignment: `center`,
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            width: 250,
            bold: false,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationStyle: ``,
            text: `Physician’s Signature........................................................ `,
            pageBreak: ``,
            color: ``,
          },
          {
            preserveLeadingSpaces: true,
            color: ``,
            alignment: `left`,
            pageBreak: ``,
            fontSize: 15,
            bold: false,
            text: `  `,
            decorationColor: ``,
            decoration: ``,
            width: 30,
            decorationStyle: ``,
          },
          {
            bold: false,
            fontSize: 15,
            width: 200,
            color: ``,
            text: `Witness 2........................................................`,
            decorationColor: ``,
            decoration: ``,
            alignment: `center`,
            decorationStyle: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            text: `(.............................................................)`,
            pageBreak: ``,
            decorationStyle: ``,
            width: 250,
            alignment: `center`,
            bold: false,
            decoration: ``,
            color: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decorationColor: ``,
          },
          {
            preserveLeadingSpaces: true,
            color: ``,
            decorationStyle: ``,
            decoration: ``,
            width: 30,
            fontSize: 15,
            decorationColor: ``,
            text: ``,
            bold: false,
            pageBreak: ``,
            alignment: `left`,
          },
          {
            decorationStyle: ``,
            bold: false,
            alignment: `center`,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            width: 200,
            fontSize: 15,
            decorationColor: ``,
            text: `(.............................................................)`,
            color: ``,
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            fontSize: 15,
            pageBreak: ``,
            decorationColor: ``,
            text: `(Physician provides explanation)`,
            preserveLeadingSpaces: true,
            width: 250,
            alignment: `center`,
          },
          {
            width: 30,
            decorationColor: ``,
            text: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            bold: false,
            fontSize: 15,
            decorationStyle: ``,
            color: ``,
            alignment: `left`,
            decoration: ``,
          },
          {
            pageBreak: ``,
            decorationColor: ``,
            width: 200,
            preserveLeadingSpaces: true,
            alignment: `center`,
            bold: false,
            decorationStyle: ``,
            color: ``,
            text: `(Fingerprint/consent over telephone)`,
            fontSize: 15,
            decoration: ``,
          },
        ],
      },
      {
        columns: [
          {
            decorationStyle: ``,
            pageBreak: ``,
            fontSize: 15,
            width: 250,
            bold: false,
            decorationColor: ``,
            alignment: `center`,
            preserveLeadingSpaces: true,
            decoration: ``,
            text: `Date........................Time..................`,
            color: ``,
          },
        ],
      },
      {
        pageBreak: ``,
        color: ``,
        fontSize: 15,
        bold: false,
        decorationColor: ``,
        text: ` `,
        preserveLeadingSpaces: true,
        alignment: `left`,
        width: `auto`,
        decorationStyle: ``,
        decoration: ``,
      },
      {
        columns: [
          {
            decorationStyle: ``,
            fontSize: 15,
            alignment: `left`,
            text: `Interpreter’s Statement`,
            pageBreak: ``,
            color: ``,
            width: `auto`,
            decoration: `underline`,
            bold: `true`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        bold: false,
        decorationColor: ``,
        text: `I have given a translation of Pre Procedural Sedation and Pre Anesthesia Informed Consent including information that physician has explained to patient/patient’s representative.`,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        fontSize: 15,
        decoration: ``,
        alignment: `left`,
        color: ``,
        width: `auto`,
        decorationStyle: ``,
      },
      {
        decorationColor: ``,
        fontSize: 15,
        pageBreak: ``,
        bold: false,
        width: `auto`,
        text: ` `,
        alignment: `left`,
        decoration: ``,
        preserveLeadingSpaces: true,
        color: ``,
        decorationStyle: ``,
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            color: ``,
            decorationStyle: ``,
            decorationColor: ``,
            decoration: ``,
            pageBreak: ``,
            text: `Translate to Language..................................... `,
            width: 200,
            fontSize: 15,
            bold: false,
            alignment: `center`,
          },
          {
            decorationStyle: ``,
            color: ``,
            fontSize: 15,
            text: ` `,
            preserveLeadingSpaces: true,
            decoration: ``,
            alignment: `left`,
            bold: false,
            width: 80,
            decorationColor: ``,
            pageBreak: ``,
          },
          {
            decorationStyle: ``,
            decorationColor: ``,
            bold: false,
            text: `Interpreter........................................................`,
            pageBreak: ``,
            alignment: `center`,
            preserveLeadingSpaces: true,
            decoration: ``,
            width: 200,
            color: ``,
            fontSize: 15,
          },
        ],
      },
      {
        columns: [
          {
            decorationColor: ``,
            decorationStyle: ``,
            color: ``,
            alignment: `left`,
            fontSize: 15,
            pageBreak: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            bold: false,
            width: 280,
            text: ``,
          },
          {
            decorationColor: ``,
            bold: false,
            preserveLeadingSpaces: true,
            color: ``,
            fontSize: 15,
            decoration: ``,
            decorationStyle: ``,
            pageBreak: ``,
            alignment: `center`,
            text: `(.............................................................)`,
            width: 200,
          },
        ],
      },
      {
        text: ` `,
        preserveLeadingSpaces: true,
        alignment: `left`,
        width: `auto`,
        decorationStyle: ``,
        color: ``,
        fontSize: 15,
        decorationColor: ``,
        decoration: ``,
        pageBreak: `before`,
        bold: false,
      },
      AddTablePreSedationEN,
    ],
    header: props.header,
    footer: props.footer,
  };
}
